angular.module('rjmNg.directives').directive "chartbuilder", [
  "$http"
  "app"
  "$url"
  "$q"
  "Journal"
  "ConnectionMeta"
  ($http, app, $url, $q, Journal, ConnectionMeta) ->
    restrict: "E"
    scope:
      chart: "="
      create: "="
      trendId: "="
      dashId: "="
      cohortDefault: "="
    controller: [
      "$scope"
      "$element"
      "$attrs"
      ($scope, $element, $attrs) ->
        @baseChartPromise = null
        @gaConnectionsPromise = null
        @lsPromise = null
        @editChart = (chart) ->
          start = new Date()

          $q.all([@gaConnectionsPromise, @lsPromise]).then (results) ->

            rjm.app.localStructure = results[1].data

            rjm.app.controller = new rjm.chartBuilderController(
              dashboardId : $scope.dashId
              clientId  : app.getClientId()
              chartId : chart.id
              chartModel : chart
              gaConnections : results[0]
              target  : $('#chartBuilderContainer')
              isCreate : false
              cohortDefault : $scope.cohortDefault
            )

            rjm.app.controller.start()

            # Log this to the journal
            Journal.save
              type: 'New Chart Builder Usage'
              key: 'Open'
              value: (new Date() - start) / 1000
              meta:
                clientId: "#{app.getClientId()}" # Previously, this was stored as a string so I'm matching that behavior here
                userId: app.getUserId()
                isSupportUser: app.isSupportUserSession()
                action: 'edit'

        @createChart = () ->
          start = new Date()

          $q.all([@baseChartPromise, @gaConnectionsPromise, @lsPromise]).then (results) ->

            rjm.app.localStructure = results[2].data

            rjm.app.controller = new rjm.chartBuilderController(
              dashboardId : $scope.dashId
              clientId  : app.getClientId()
              chartId : 0
              chartModel : results[0].data
              gaConnections : results[1]
              target  : $('#chartBuilderContainer')
              isCreate : true
              trendId : $scope.trendId
              cohortDefault : $scope.cohortDefault
            )

            rjm.app.controller.start()

            # Log this to the journal
            Journal.save
              type: 'New Chart Builder Usage'
              key: 'Open'
              value: (new Date() - start) / 1000
              meta:
                clientId: "#{app.getClientId()}" # Previously, this was stored as a string so I'm matching that behavior here
                userId: app.getUserId()
                isSupportUser: app.isSupportUserSession()
                action: 'create'
        @
    ]
    link: ($scope, $element, $attrs, $controller) ->

      Backbone.emulateHTTP = true

      if _.keys(ich.templates).length is 0
        $http(
          method: 'GET'
          url: $url('/chartBuilder/template?c='+app.getClientId())
        )
        .then(({data}) ->
          angular.forEach(data, (template, i) ->
            ich.addTemplate(template.name, template.template);
          )
        )

      $controller.baseChartPromise = $http(
        method: "GET"
        url: $url("/chartBuilder/#{app.getClientId()}/baseChart")
        cache: true
      )

      $controller.gaConnectionsPromise = ConnectionMeta(app.getClientId()).gaConnections()

      $controller.lsPromise = $http(
        method: "GET"
        url: $url("/client/#{app.getClientId()}/ls")
        cache: true
      )

      $scope.$watch 'chart', (chart, old) ->

        if chart is old
          return

        if chart?
          $element.show()
          $controller.editChart(chart)
        else
          $element.hide()


      $scope.$watch 'create', (create, old) ->

        if create
          $element.show()
          $controller.createChart()
        else
          $element.hide()

      $scope.$on "closeChartBuilder", ->
        rjm.app.controller?.destroy()
]
